import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type InvoiceConfigOwner = {
  id: number
  name: string
}

export type InvoiceConfigCustomWeek = {
  weekStartDay: string
  timezone: string
}

export type InvoiceConfig = {
  id: number
  company: InvoiceConfigOwner | null
  companyGroup: InvoiceConfigOwner | null
  breakdownLevels: string[]
  customWeek: InvoiceConfigCustomWeek | null
  createdAt: string
  updatedAt: string
}

type GetInvoiceConfigsRequest = {
  page: number
  pageSize: number
  companyId?: number
  breakdownLevels?: string[]
}

type GetInvoiceConfigsResponse = {
  items: InvoiceConfig[]
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const getInvoiceConfigs = async (
  request: GetInvoiceConfigsRequest
): Promise<GetInvoiceConfigsResponse> => {
  const response = await api.get<GetInvoiceConfigsResponse>(
    '/admin/invoice_config',
    {
      params: {
        page: request.page,
        pageSize: request.pageSize,
        companyId: request.companyId,
        breakdownLevels: request.breakdownLevels,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return response.data
}
